import { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { getCategories, refreshTransactionsCategory } from 'actions';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { deleteCategory } from 'actions/expenses';
import { getBudgets } from 'features/budgeting/actions';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import { selectCategoryHasSubcategories } from 'reducers/selectors';
const useDeleteCategory = () => {
    const dispatch = useAppDispatch();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const store = useAppStore();
    const onDelete = useCallback((id, onDeleted) => {
        const onConfirm = () => {
            fetch(deleteCategory(id)).then((response) => {
                if (response) {
                    dispatch(getCategories());
                    dispatch(getBudgets());
                    dispatch(refreshTransactionsCategory());
                    onDeleted?.();
                }
                return response;
            });
        };
        const hasSubcategories = selectCategoryHasSubcategories(store.getState(), id);
        Modal.hide();
        Modal.showConfirmation({
            title: 'Are you sure?',
            subtitle: hasSubcategories
                ? 'This action will delete all subcategories belonging to this parent category. This cannot be undone. Do you want to delete it?'
                : 'Do you want to delete this category? All transactions within this category will be moved back to their original categories, or to General. This action cannot be undone.',
            confirmButtonTitle: 'No, thanks',
            cancelButtonTitle: 'Yes, let me delete',
            onPressCancel: onConfirm,
        });
    }, []);
    return [isFetching, onDelete];
};
export default useDeleteCategory;
